module.exports = __webpack_public_path__ + "static/media/country_ta.335c5b0f.webp";